export enum LendioState {
    welcome,
    financial,
    bankSelection,
    verification,
    payment,
    thankYou
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/LendioState.ts